module.exports = __webpack_public_path__ + "static/media/Artboard19.c96357a8.png";